import { Center, Group, Pagination, Select, Text } from '@mantine/core';

interface ServerPaginationControlProps {
  currentPage: number;
  totalPages: number;
  perPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
}

export const ServerPaginationControl = ({
  currentPage,
  totalPages,
  perPage,
  totalCount,
  onPageChange,
  onPerPageChange,
}: ServerPaginationControlProps) => {
  const handlePerPageChange = (newPerPage: string | null) => {
    if (newPerPage !== null) {
      const newPerPageNumber = parseInt(newPerPage, 10);
      onPerPageChange(newPerPageNumber);
    }
  };

  // Don't render if there are no items
  if (totalCount === 0) {
    return null;
  }

  return (
    <Center mt="md">
      <Group>
        <Pagination
          total={Math.max(totalPages, 1)}
          value={currentPage}
          onChange={onPageChange}
          siblings={1}
          boundaries={1}
        />
        <Group gap="xs">
          <Text>Показать</Text>
          <Select
            value={perPage.toString()}
            onChange={handlePerPageChange}
            data={[
              { value: '10', label: '10' },
              { value: '20', label: '20' },
              { value: '50', label: '50' },
            ]}
            style={{ width: '80px' }}
          />
          <Text>из {totalCount} книг</Text>
        </Group>
      </Group>
    </Center>
  );
};
